import Styled from 'styled-components';
import { v2Color } from '@theme/v2';

/* Top REGA summary band (Figma): REGA Details / type / price · license · location · area · QR.
 * Shared so the post-listing "See More Details" modal and the ad-license "View More Details" detail
 * render an identical band. */
export const Band = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  height: 128.39px;
  padding: 24px 68px;
  background: linear-gradient(180deg, ${v2Color('#F2FAFA')} 0%, #FFFFFF 154.69%);

  @media (max-width: 767px) {
    flex-direction: column;
    height: auto;
    padding: 16px;
    gap: 16px;
  }

  .label { color: #707070; font-size: 12px; font-weight: 700; line-height: 18px; margin: 0 0 6px; }
  .type { color: #000000E0; font-size: 14px; font-weight: 700; line-height: 20px; margin: 0 0 6px; }
  .price { color: ${v2Color('#006169', 'text')}; font-size: 24px; font-weight: 700; line-height: 30px; margin: 0;
           display: flex; align-items: center; gap: 6px; }
  .price svg { width: 18px; height: 22px; }

  .info { display: flex; flex-direction: column; gap: 12px; }
  .info .row { display: flex; align-items: center; gap: 8px; color: #222222; font-size: 14px; line-height: 20px; }
  .info .row .lbl { color: #707070; }
  .info .row .val { color: #222222; font-weight: 600; }

  .qr { display: flex; flex-direction: column; align-items: center; gap: 10px; }
  .rega-link { display: inline-flex; align-items: center; justify-content: center; gap: 4px; color: ${v2Color('#006169', 'text')};
               font-size: 12px; font-weight: 400; white-space: nowrap; }
`;
